// Class: openfl.net.Responder

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var Responder = function(result,status) {
	this.__result = result;
	this.__status = status;
}

// Meta

Responder.__name__ = "openfl.net.Responder";
Responder.__isInterface__ = false;
Responder.prototype = {
	
};
Responder.prototype.__class__ = Responder.prototype.constructor = $hxClasses["openfl.net.Responder"] = Responder;

// Init



// Statics




// Export

exports.default = Responder;